export const categories = [
  {
    name: 'Arithmetic',
    description: 'Master basic mathematical calculations essential for all competitive exams',
    topics: [
      { 
        name: 'Number System', 
        url: '/exam/number-system-questions',
        description: 'Practice questions on natural numbers, integers, rational and irrational numbers',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Simplification', 
        url: '/exam/simplification-questions',
        description: 'Questions on BODMAS rule, fractions, decimals, and surds',
        difficulty: 'Medium',
        examFrequency: 'Very High'
      },
      { 
        name: 'HCF and LCM', 
        url: '/exam/hcf-and-lcm-questions',
        description: 'Problems on finding highest common factor and least common multiple',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
      { 
        name: 'Average', 
        url: '/exam/average-and-percentage-problems',
        description: 'Questions on calculating mean values and weighted averages',
        difficulty: 'Easy',
        examFrequency: 'High'
      },
      { 
        name: 'Percentage', 
        url: '/exam/average-and-percentage-problems',
        description: 'Problems on calculating percentages, increases and decreases',
        difficulty: 'Easy',
        examFrequency: 'Very High'
      },
      { 
        name: 'Profit and Loss', 
        url: '/exam/profit-and-loss-questions',
        description: 'Questions on calculating profit, loss, and discounts in business transactions',
        difficulty: 'Medium',
        examFrequency: 'Very High'
      },
      { 
        name: 'Discount', 
        url: '/exam/discount-questions',
        description: 'Problems on calculating discounts, marked price and selling price',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Simple Interest', 
        url: '/exam/simple-interest-and-compound-interest-questions',
        description: 'Questions on calculating interest over a period of time',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Compound Interest', 
        url: '/exam/simple-interest-and-compound-interest-questions',
        description: 'Problems on interest compounded annually, half-yearly or quarterly',
        difficulty: 'Hard',
        examFrequency: 'High'
      },
      { 
        name: 'Ratio and Proportion', 
        url: '/exam/ratio-and-proportion-questions',
        description: 'Questions on comparing quantities and solving proportions',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Partnership', 
        url: '/exam/partnership-questions',
        description: 'Problems on partnership businesses and profit sharing',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
      { 
        name: 'Mixture and Alligation', 
        url: '/exam/mixture-and-alligation-questions',
        description: 'Questions on mixing different items and calculating ratios',
        difficulty: 'Hard',
        examFrequency: 'Medium'
      },
      { 
        name: 'Time and Work', 
        url: '/exam/time-and-work-questions',
        description: 'Problems on work efficiency, time taken, and multiple workers',
        difficulty: 'Medium',
        examFrequency: 'Very High'
      },
      { 
        name: 'Pipe and Cistern', 
        url: '/exam/pipe-and-cistern-questions',
        description: 'Questions on filling and emptying tanks through pipes',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
      { 
        name: 'Speed, Time, and Distance', 
        url: '/exam/time-speed-and-distance-questions',
        description: 'Problems on calculating speed, time, and distance relationships',
        difficulty: 'Medium',
        examFrequency: 'Very High'
      },
      { 
        name: 'Boat and Stream', 
        url: '/exam/boat-and-stream-questions',
        description: 'Questions on upstream and downstream movement in rivers',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
    ],
  },
  {
    name: 'Algebra',
    description: 'Practice equations, expressions, and variables for competitive exams',
    topics: [
      { 
        name: 'Basics of Algebra', 
        url: '/exam/algebra-questions',
        description: 'Fundamental algebraic concepts, expressions and identities',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Linear Equations', 
        url: '/exam/linear-equations-questions',
        description: 'Solving equations with one or more variables',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Quadratic Equations', 
        url: '/exam/quadratic-equations-questions',
        description: 'Solving second-degree equations and finding roots',
        difficulty: 'Hard',
        examFrequency: 'High'
      }    
    ],
  },
  {
    name: 'Geometry',
    description: 'Study properties and relations of points, lines, and surfaces',
    topics: [
      { 
        name: 'Basics of Geometry (Lines, Angles)', 
        url: '/exam/geometry-questions',
        description: 'Fundamental concepts of lines, angles, and their properties',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
      { 
        name: 'Triangles (Properties, Similarity, Congruence)', 
        url: '/exam/triangles-questions',
        description: 'Problems on triangle properties, similarity, and congruence',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Circles (Properties and Theorems)', 
        url: '/exam/circles-questions',
        description: 'Questions on circle properties, chords, tangents, and secants',
        difficulty: 'Hard',
        examFrequency: 'Medium'
      },
      { 
        name: 'Polygons', 
        url: '/exam/polygons-questions',
        description: 'Problems on regular and irregular polygons and their properties',
        difficulty: 'Medium',
        examFrequency: 'Low'
      },
      { 
        name: 'Coordinate Geometry', 
        url: '/exam/coordinate-geometry-questions',
        description: 'Questions on points, lines, and shapes in coordinate systems',
        difficulty: 'Hard',
        examFrequency: 'Medium'
      },
    ],
  },
  {
    name: 'Mensuration',
    description: 'Calculate areas, volumes, and perimeters of geometric figures',
    topics: [
      { 
        name: 'Area and Perimeter of 2D Figures', 
        url: '/exam/area-and-perimeter-questions',
        description: 'Calculating area and perimeter of squares, rectangles, circles, and polygons',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Surface Area and Volume of 3D Figures', 
        url: '/exam/surface-area-and-volume-questions',
        description: 'Problems on cubes, cuboids, cylinders, cones, and spheres',
        difficulty: 'Hard',
        examFrequency: 'Medium'
      },
    ],
  },
  {
    name: 'Trigonometry',
    description: 'Explore relationships between angles and sides of triangles',
    topics: [
      { 
        name: 'Trigonometric Ratios', 
        url: '/exam/trigonometric-ratios-questions',
        description: 'Understanding sine, cosine, tangent and other ratios',
        difficulty: 'Hard',
        examFrequency: 'Medium'
      },
      { 
        name: 'Trigonometric Identities', 
        url: '/exam/trigonometric-identities-questions',
        description: 'Problems using fundamental trigonometric identities',
        difficulty: 'Hard',
        examFrequency: 'Low'
      },
      { 
        name: 'Heights and Distances', 
        url: '/exam/heights-and-distances-questions',
        description: 'Application of trigonometry to calculate heights and distances',
        difficulty: 'Hard',
        examFrequency: 'Medium'
      },
    ],
  },
  {
    name: 'Data Interpretation',
    description: 'Analyze and interpret data from tables, graphs, and charts',
    topics: [
      { 
        name: 'Tabular Data', 
        url: '/exam/tabular-data-interpretation',
        description: 'Interpreting information presented in tables and matrices',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Bar Graphs', 
        url: '/exam/bar-graph-interpretation',
        description: 'Analyzing data presented in vertical and horizontal bar charts',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Pie Charts', 
        url: '/exam/pie-chart-interpretation',
        description: 'Understanding data represented in circular proportional diagrams',
        difficulty: 'Medium',
        examFrequency: 'High'
      },
      { 
        name: 'Line Graphs', 
        url: '/exam/line-graph-interpretation',
        description: 'Analyzing trends and patterns in line graphs',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
    ],
  },
  {
    name: 'Miscellaneous',
    description: 'Additional important mathematical concepts for competitive exams',
    topics: [
      { 
        name: 'Sets and Venn Diagrams', 
        url: '/exam/sets-and-venn-diagrams-questions',
        description: 'Problems on set operations and representation using Venn diagrams',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
      { 
        name: 'Sequence and Series', 
        url: '/exam/sequences-and-series-questions',
        description: 'Questions on arithmetic, geometric, and other sequences',
        difficulty: 'Hard',
        examFrequency: 'High'
      },
      { 
        name: 'Probability', 
        url: '/exam/probability-questions',
        description: 'Problems on calculating the likelihood of events',
        difficulty: 'Hard',
        examFrequency: 'High'
      },
      { 
        name: 'Permutations and Combinations', 
        url: '/exam/permutations-and-combinations-questions',
        description: 'Questions on arranging and selecting objects',
        difficulty: 'Hard',
        examFrequency: 'High'
      },
      { 
        name: 'Problems on Ages', 
        url: '/exam/problems-on-ages-questions',
        description: 'Solving age-related puzzles and equations',
        difficulty: 'Medium',
        examFrequency: 'Medium'
      },
    ],
  },
];

// Additional metadata for SEO
export const aptitudeMetadata = {
  pageTitle: "Quantitative Aptitude Mock Tests | Free Practice for Competitive Exams",
  mainKeywords: [
    "quantitative aptitude questions",
    "aptitude mock test",
    "aptitude practice test",
    "free aptitude test",
    "bank exam aptitude",
    "SSC aptitude questions",
    "competitive exam preparation",
    "aptitude questions with solutions",
    "percentage problems",
    "profit and loss questions",
    "time and work problems",
    "probability questions",
    "arithmetic aptitude",
    "algebra questions",
    "geometry problems"
  ],
  examTypes: [
    {
      name: "Bank Exams",
      exams: ["SBI PO", "IBPS PO", "IBPS Clerk", "RBI Grade B", "NABARD"],
      aptitudeWeight: "High (25-35% of total marks)"
    },
    {
      name: "SSC Exams",
      exams: ["SSC CGL", "SSC CHSL", "SSC MTS", "SSC CPO"],
      aptitudeWeight: "Very High (35-45% of total marks)"
    },
    {
      name: "Railway Exams",
      exams: ["RRB NTPC", "RRB Group D", "RRB JE", "RRB ALP"],
      aptitudeWeight: "High (25-30% of total marks)"
    },
    {
      name: "Other Government Exams",
      exams: ["UPSC Prelims", "State PSC", "Defense Exams (CDS, AFCAT)"],
      aptitudeWeight: "Medium (15-25% of total marks)"
    }
  ],
  popularTopics: [
    "Percentage", 
    "Profit and Loss", 
    "Time and Work", 
    "Speed, Time and Distance", 
    "Simple and Compound Interest",
    "Ratio and Proportion",
    "Probability",
    "Quadratic Equations"
  ]
};
